<template>
  <div class="yxt-category-tree" v-infinite-scroll="load">
    <yxt-input
      v-if="!hideSearch"
      class="yxt-category-tree-search"
      v-model="keyword"
      searchable
      :placeholder="placeholder"
      @search="search"
      :maxlength="20"
      clearable
    ></yxt-input>
    <yxt-checkbox v-if="selectedDirectoryRange" :style="hideSearch ? 'margin-top: 0;' : 'margin-top: 16px;'" v-model="selectedIncludeChildDir">
      {{ text1 }}</yxt-checkbox>
    <div class="yxt-category-tree-content" :style=" hideSearch && !selectedDirectoryRange ? 'margin-top: 0; height: 100%;' : ''">
      <yxt-empty v-if="empty" />
      <tree-node
        v-else
        :activeId="activeId"
        :checkType="this.mode === 1 ? 0 : checkType"
        :rootType="rootType"
        :mode="mode"
        :limit="limit"
        :settings="settings"
        :sort="sort"
        :deleteFunc="deleteFunc"
        :handle-click="handleClick"
        :handle-check="handleCheck"
        :showForm="showForm"
        :showExport="showExport"
        :checkedIds="checkedList"
        :parentResetCheckChild="resetCheckChild"
        :data="data"
        :searchState="!!keyword"
        :multiple="multiple && mode === 2"
        :pnodeId="treeData && treeData.nodeId || '0'"
        :index="0"
        :expandAll="expandALL"
        :containChildren="false"
        :expandedDefault="true"
        :sortable="sortable && mode === 1"
        :firstModifiable="mode === 1 ? firstModifiable : false"
        :modifiable="mode === 1 ? modifiable : {}"
        :get-cate-children="getCateChildren"
        :nodeRender="nodeRender"
      ></tree-node>
    </div>
  </div>
</template>
<script>
import TreeNode from './components/tree-node';
import Locale from '@utils/mixins/locale';
export default {
  name: 'YxtCategoryTree',
  mixins: [Locale],
  components: {
    TreeNode
  },
  data() {
    return {
      text1:  '',
      data: JSON.parse(JSON.stringify(this.treeData)),
      keyword: '',
      expandAll: false,
      isSearching: false,
      formVisble: false,
      formCallback: null, // 表单保存后的回调函数
      checkedMap: {},
      activeNode: null,
      title: '',
      apiInstance: null,
      checkedList: [],
      activeId: '',
      selectedIncludeChildDir: false 
    };
  },
  props: {
    expandALL: {
      type: Boolean,
      default: false
    },
    checkType: {
      type: Number,
      default: 0 // 1：选择所属部门(当前全部)，2：选择部门范围（后续新增)
    },
    // 根节点[不支持关联数据]的开关
    rootType: {
      type: Number,
      default: 1 // 1：开启--不允许关联数据，2：未开启--允许关联数据
    },
    showExport: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {
        return {
          add: {
            text: '新增'
          },
          delete: {
            text: '删除'
          },
          modify: {
            text: '编辑'
          }
        };
      }
    },
    mode: {
      type: Number,
      default: 1 // 1（操作树），2（选择树 )
    },
    value: {
      type: [Array, String, Number]
    },
    // checkedIds: {
    //   type: Array || String || Number,
    //   default: () => {
    //     return [];
    //   }
    // },
    multiple: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入关键字搜索'
    },
    // 一级分类是否允许增删改
    firstModifiable: {
      type: Boolean,
      default: false
    },
    // 除一级分类以外的分类是否允许增删改
    modifiable: {
      type: Object,
      default: () => {
        return {
          add: false,
          delete: false,
          modify: false
        };
      }
    },
    // 多选最大数量
    limit: {
      type: Number,
      default: 0
    },
    // tree数据
    treeData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 是否显示搜索框
    hideSearch: {
      type: Boolean,
      default: false
    },
    // 选中时是否包含下级目录是否开启
    selectedDirectoryRange: {
      type: Boolean,
      default: false
    },
    selectedIncludeChildDirProp: {
      type: Boolean,
      default: false
    },
    nodeRender:{
      type: Function
    }
  },
  computed: {
    empty() {
      return !this.data || !this.data.children;
    },
    checkedIds() {
      return this.value || '';
    }
  },
  watch: {

    // prop
    selectedIncludeChildDirProp: {
      immediate: true,
      handler(val) {
        console.log('prop selectedIncludeChildDirProp....', val)
        this.selectedIncludeChildDir = val
      },
    },
    // data
    selectedIncludeChildDir: {
      immediate: true,
      handler(val) {
        this.$emit('update:selectedIncludeChildDirProp', val)
      },
    },
    checkedIds(val) {
      if (this.mode === 1) {
        return;
      }
      if ((typeof val === 'string' || typeof val === 'number') && !this.multiple) {
        this.checkedList = val;
      } else if (Array.isArray(val) && this.multiple) {
        this.checkedList = [...val];
      } else {
        console.warn('checkedIds类型错误', val);
      }
    },
    treeData() {
      this.data = {};
      this.$nextTick(() => {
        this.data = JSON.parse(JSON.stringify(this.treeData));
      });
    }
  },
  created() {
    this.checkedListInit();
    this.text1 = this.t('pc_common_selected_directory_range');
  },
  methods: {
    resetCheckChild() {},
    checkedListInit() {
      if (this.mode === 1) {
        return;
      }
      if ((typeof this.checkedIds === 'string' || typeof this.checkedIds === 'number') && !this.multiple) {
        this.checkedList = this.checkedIds;
      } else if (Array.isArray(this.checkedIds) && this.multiple) {
        this.checkedList = [...this.checkedIds];
      } else {
        console.warn('checkedIds类型错误', this.checkedIds);
      }
    },
    // 搜索后并展开所有节点
    search() {
      this.$emit('search', this.keyword, function(treeList) {
        const { node } = treeList || {};
        if (node) {
          this.treeData = node;
        } else {
          this.treeData = {};
        }
      });
    },
    // 逐级展开下一分类，获取子分类列表
    getCateChildren(nodeId, fn) {
      this.$emit('getCateChild', nodeId, fn);
    },
    deleteFunc(nodeId, fn) {
      this.$emit('deleted', nodeId, fn);
    },
    sort(data, callback) {
      this.$emit('drag', data, callback);
    },
    showForm({ type, nodeId, callback }) {
      if (type === 'create') {
        this.$emit('create', nodeId, callback);
      } else if (type === 'export') {
        this.$emit('export', nodeId);
      } else {
        this.$emit('edit', nodeId, callback);
      }
    },
    setSelectedIncludeChildDir(val) {
      this.selectedIncludeChildDir = val;
    },
    handleClick(node, obj) {
      // if (this.activeNode) {
      //   this.activeNode.active = false;
      // }
      // if (node) {
      //   node.active = true;
      //   this.activeNode = node;
      // }
      if (this.mode === 1) {

        // 开启了目录范围控制
        if (this.selectedDirectoryRange) {
          // 多传递一个值表示是否包含子目录
          this.$emit('actived', node.nodeId, obj, {
            selectedIncludeChildDir: this.selectedIncludeChildDir,
            selectedDirectoryRange: this.selectedDirectoryRange
          });
        } else {
          this.$emit('actived', node.nodeId, obj);
        }
        this.activeId = node.nodeId;
      }
      if (this.mode === 2) {
        this.updatedCheckedIds(node.nodeId, true, node.nodeName);
      }
    },
    load() {},
    handleCheck(isChecked, nodeId, nodeName, children) {
      this.updatedCheckedIds(nodeId, isChecked, nodeName, children);
    },
    getCheckIds() {
      return this.checkedList;
    },
    updatedCheckedIds(nodeId, isChecked, nodeName, children) {
      if (isChecked) {
        if (this.multiple) {
          if (children) {
            if (this.limit > 0 && children.length + this.checkedList.length > this.limit) {
              return this.$message.warning(this.t('pc_biz_cate_max_limit1') + this.limit + this.t('pc_biz_cate_max_limit3'));
            }
            children.forEach(node => {
              if (!this.checkedList.includes(node.nodeId)) {
                this.checkedList.push(node.nodeId);
              }
            });
            return this.$emit('selecteds', children, true, this.checkType === 2 ? 1 : 0);
          } else {
            this.checkedList.push(nodeId);
          }
        } else {
          this.checkedList = nodeId;
        }
      } else {
        if (this.multiple) {
          const index = this.checkedList.findIndex(
            item => item === nodeId
          );
          if (index > -1) this.checkedList.splice(index, 1);
          this.checkedList = this.checkedList;
        }
      }
      this.$emit('input', this.checkedList);
      this.$emit('selected', nodeId, isChecked, nodeName, this.checkType === 2 ? 1 : 0);
    }
  }
};
</script>
